var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"name-icon-container",style:({ width: _vm.width, height: _vm.height })},[_c('p',[_vm._v(_vm._s(_vm.initials))])])}
var staticRenderFns = []

export { render, staticRenderFns }